import React from 'react';

import Header from '../../layout/Header.jsx';
import ListLevels from '../../lists/ListLevels.jsx';

const PageLevels = () => (
  <div>
    <Header>Levels</Header>
    <ListLevels />
  </div>
);

export default PageLevels;
